import type { ReactNode } from 'react';
import { Breadcrumb, type Crumb } from './Breadcrumb';
import { PageHeader as PageHeaderShell } from '@/shared/components/ui/PageHeader';

export interface PageHeaderProps {
  title: string;
  description?: string;
  breadcrumbs?: Crumb[];
  actions?: ReactNode;
}

/**
 * The breadcrumb-carrying variant the dashboards use. It is now a thin wrapper
 * over the shared `ui/PageHeader` rather than a second page-title treatment —
 * there were two h1 styles in the shell (16px headline-md here, 20px display-sm
 * there), so the same kind of screen opened at two different sizes.
 *
 * The header itself carries no vertical margin: the page's own `space-y-*`
 * container owns the rhythm, and ContentContainer owns the gutter.
 */
export function PageHeader({ title, description, breadcrumbs, actions }: PageHeaderProps) {
  return (
    <div className="mb-5 space-y-2">
      {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumb items={breadcrumbs} />}
      <PageHeaderShell title={title} description={description} actions={actions} />
    </div>
  );
}
